import React from "react";
import Headline from "./Headline";
import { Button, Col, DatePicker, Flex, Form, FormInstance, Input, notification, Row, Select } from "antd";
import ContactUsApi from "../../api-services/contact-us-api.service";
import HomeLink from "../../widgets/HomeLink";
import Cookies from "js-cookie"
import ListApi from "../../api-services/list-api.service";
import AgentsApi from "../../api-services/agents-api.service";
import LocationsApi from "../../api-services/locations-api.service";

const { TextArea } = Input;

const customCookies = Cookies.withAttributes({
  expires: 14
});

const bannerPath = '/iceholidays-assets/images/corporate/GD_MICE_Desktop.png';
const mobileBannerPath = '/iceholidays-assets/images/corporate/GD_MICE_Mobile.png';

const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'GD MICE' }
]

const miceLogoPath = '/iceholidays-assets/images/mice-logo-new.png';

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

const storedArray$ = (array) => Promise.resolve(JSON.parse(array));

const formatOptions = (arr) => arr.map(({name}) => ({value: name, label: name}));

export default class CorporateMicePage extends React.Component {
  api = new ContactUsApi;
  listApi = new ListApi;
  agentsApi = new AgentsApi;
  locationsApi = new LocationsApi;
  contactForm = React.createRef<FormInstance>();

  state = {
    titles: [],
    states: [],
    cities: [],
    roles: [],
    airlines: [],
    agents: [],
    locations: [],
    filteredStates: [],
    filteredCities: []
  }


  componentDidMount() {
    const storedCities = customCookies.get("cities-Malaysia");
    Promise.all(
      [
        this.listApi.getTitles(),
        storedCities == undefined ? this.listApi.getCities({country: "Malaysia"}) : storedArray$(storedCities),
        this.listApi.getRoles(),
        this.listApi.getAirlines(),
        this.agentsApi.getAgents(['Series', 'Flight', 'Visa']),
        this.locationsApi.getLocations({brands: ["GD_In_Depth", "GD_Standard"]}),
      ]
    ).then(([titles, cities, roles, airlines, agents, locationsData]) => {
      const states = this.listApi.getStatesOptionsByCities(cities);
      customCookies.set('cities-Malaysia', JSON.stringify(cities))

      const locations:any = locationsData.locations;
      const locationsOptions = locations.map(({name, children}) => ({title: name, label: name, options: formatOptions(children)}))
        this.setState({titles, states, cities, roles, airlines, agents: formatOptions(agents), locations: locationsOptions, filteredStates: states, filteredCities: cities})
      })
      .catch(error => {
        notification.error({ message: 'Something went wrong.'});
      });
  }

  fetchCities = (searchStr:string) => {
    this.listApi.getCities({term: searchStr})
      .then(filteredCities => this.setState({filteredCities}));
  }

  filterCities = (selectedState) => {
    const storedCities = customCookies.get(`cities-${selectedState}`);
    (storedCities == undefined ? this.listApi.getCities({state: selectedState}) : storedArray$(storedCities))
      .then(filteredCities => {
        customCookies.set(`cities-${selectedState}`, JSON.stringify(filteredCities))
        this.setState({filteredCities});
    });
  }

  filterStates = (selectedCity, option) => {
    const {states} = this.state;
    var filteredStates = states;

    if(selectedCity){
      filteredStates = states.filter(({value}) => value == option.state)
    }

    this.setState({filteredStates})
  }

  submitForm(formValues) {
    const form = {
      kind: 'general_mice_inquiry',
      name: `${formValues.title} ${formValues.firstName} ${formValues.lastName}`,
      email: formValues.email,
      message: formValues.message,
      phone: formValues.personalPhoneNumber,
      office_number: formValues.officePhoneNumber,
      state: formValues.state,
      city: formValues.city,
      address: formValues.address,
      address2: formValues.address2,
      role: formValues.role,
      budget: formValues.budget,
      no_of_travellers: formValues.travellersCount,
      departure_date: formValues.departureDate,
      airline: formValues.airline,
      agent: formValues.agent,
      destination: formValues.destination,
    }
      this.api.contactInquiry(form)
        .then(success => {
          if(success){
            notification['success']({message: "Inquiry sent."});
            this.contactForm.current?.resetFields();
          }
        })
        .catch(error => {
          notification.error({ message: 'An error occured while sending inquiry.'});
        });
  }



  render(){
    const {titles, filteredStates, filteredCities, roles, airlines, agents, locations} = this.state;
    return (
      <div className="mice-page">
        <Headline showSearch={false} bannerImage={bannerPath} mobileBannerImage={mobileBannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            <img src={miceLogoPath} alt="MICE Logo" />
          </span>
        </Headline>

        <div className="mice-page_body mice-page_body-forms">
          <div id="header">
            <h1> GD MICE </h1>
            <h4>Custom-Made Travel Solutions For Every Business Need </h4>
            <span>Meetings | Incentives | Conferences | Events</span>
            <p>GD MICE is established to help partners capture growing opportunities in the MICE market.</p>
            <p>We create fully customised corporate and group travel solutions across industries, regions, and business sizes.</p>
            <p>Powered by GD Group Berhad Impact Business Module, GD MICE operates on B2B, B2B2C, and B2C2B models—strengthening partner collaboration, enhancing customer reach, and improving market scalability.</p>
            <p>With the backing of ICE Holidays’ industry experience, financial strength, and strong procurement network, GD MICE delivers:</p>
            <p>Customised programs</p>
            <p>Advantageous cost-performance ratio</p>
            <p>Comprehensive backup support</p>
            <p>Seamless end-to-end arrangements</p>
            <p>From business meetings and incentive trips to conferences and signature group experiences, GD MICE ensures value, reliability, and memorable journeys—supported by our nationwide partner network.</p>
            <p>Please fill out the contact form below to get your quote</p>
          </div>

          <Form
            ref={this.contactForm}
            autoComplete="off"
            layout="vertical"
            variant="filled"
            validateMessages={validateMessages}
            onFinish={(formValues)=>this.submitForm(formValues)}
            className="mice-form"
          >

            <div className="mice-form-group">
              <label>Personal Details</label>
              <Row gutter={[16,16]}>
                <Col xs={24} md={8}>
                  <Form.Item label="Title" name="title" required>
                    <Select placeholder="Mr" options={titles}/>
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="First Name" name="firstName" required>
                    <Input placeholder="Enter First Name" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Last Name" name="lastName" required>
                    <Input placeholder="Enter Last Name" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Street Address" name="address" required>
                    <Input placeholder="Enter Address" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Street Address Line 2" name="address2">
                    <Input placeholder="Enter Address 2" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="State" name="state">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Please Select"
                      options={filteredStates}
                      onChange={this.filterCities}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="City" name="city">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Please Select"
                      options={filteredCities}
                      onChange={this.filterStates}
                      filterOption={false}
                      onSearch={this.fetchCities}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Office Phone Number" name="officePhoneNumber" required>
                    <Input placeholder="Enter Office Phone Number" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Personal Phone Number" name="personalPhoneNumber" required>
                    <Input placeholder="Enter Personal Phone Number" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Email" name="email" rules={[{ type: 'email' }]} required>
                    <Input placeholder="Enter Email" />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="mice-form-group">
              <label>Travel Details</label>
              <Row gutter={[16,16]}>
                <Col xs={24} md={12}>
                  <Form.Item label="Destination" name="destination">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Please Select"
                      options={locations}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Your Preferred Agent" name="agent">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Choose Agent"
                      options={agents}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Choice of Airline" name="airline">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Please Select"
                      options={airlines}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Departure Date" name="departureDate">
                    <DatePicker />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Type" name="role">
                    <Select
                      placeholder="Please Select"
                      options={roles}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="No. of Travellers" name="travellersCount" required>
                    <Input type="number" placeholder="Enter No. of Travellers" required/>
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Budget" name="budget" required>
                    <Input type="number" placeholder="Enter Budget" required/>
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="mice-form-group">
              <label>More Details</label>
              <Row gutter={[16,16]}>
                <Col span={24}>
                  <Form.Item label="Message" name="message" required>
                    <TextArea rows={4} placeholder="Write your message"/>
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <Flex align="center" justify="center">
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Flex>

          </Form>

        </div>
      </div>
    )
  }
}